module.exports = __webpack_public_path__ + "media/6_1.b7937afe.wav";